import { render, staticRenderFns } from "./ArchivoAltas.vue?vue&type=template&id=44689b38&"
import script from "./ArchivoAltas.vue?vue&type=script&lang=js&"
export * from "./ArchivoAltas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports